import { BFF_API_ROUTES } from 'constants/routes';

import { baseRTKApi } from 'shared/api/baseApi';

export const queries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getProduct: build.query<any, any>({
      query: (query) => ({
        url: BFF_API_ROUTES.getProduct,
        body: query,
        method: 'POST',
      }),
    }),
  }),
});

export const { useGetProductQuery } = queries;
